<template>
    <article class="quote-form-usps__container">
        <WatsonAtomImage
            v-if="content.quoteForm?.containerImage"
            :content="content.quoteForm?.containerImage"
            class="quote-form-usps__container-image"
        />
        <div class="wordpress-columns">
            <section class="quote-form-usps__wrapper wordpress-column wordpress-column--divide-width">
                <section class="quote-form-usps">
                    <WatsonThemeUsps
                        v-if="content.usps"
                        v-bind="content.usps"
                    />

                    <WatsonThemeQuoteForm
                        v-if="content.quoteForm"
                        v-bind="content.quoteForm"
                    />
                </section>
            </section>
        </div>
    </article>
</template>

<script setup>
import WatsonThemeUsps from '../usps/watson-theme-usps.vue';
import WatsonAtomImage from '@atoms/image/watson-atom-image.vue';
import WatsonThemeQuoteForm from '../quote-form/watson-theme-quote-form.vue';

defineProps({
    content: {
        type: Object,
        required: true,
    },
});
</script>

<style lang="scss" scoped>
@use 'watson-theme-quote-form-usps';
</style>
